import { render, staticRenderFns } from "./PhotographySamples.vue?vue&type=template&id=239d4804&scoped=true&"
import script from "./PhotographySamples.vue?vue&type=script&lang=js&"
export * from "./PhotographySamples.vue?vue&type=script&lang=js&"
import style0 from "./PhotographySamples.vue?vue&type=style&index=0&id=239d4804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239d4804",
  null
  
)

export default component.exports